const PieCustomLegendPluginRebranding = (function() {
  let functions = {};

  functions.getOrCreateLegendList = (chart, id) => {
    const legendContainer = document.getElementById(id);
    let listContainer = legendContainer?.querySelector('ul');

    if (!listContainer) {
      listContainer = document.createElement('ul');
      listContainer.classList.add(
        'd-flex',
        'flex-column',
        'gap-1',
        'list-unstyled',
        'mb-0'
      );
      legendContainer.appendChild(listContainer);
    }

    return listContainer;
  };

  functions.htmlLegendPlugin = () => {
    return {
      id: 'htmlLegend',
      afterUpdate(chart, args, options) {
        const ul = functions.getOrCreateLegendList(chart, options.containerID);

        // Remove old legend items
        while (ul.firstChild) {
          ul.firstChild.remove();
        }

        // Reuse the built-in legendItems generator
        const items = chart.options.plugins.legend.labels.generateLabels(chart);

        items.forEach((item) => {
          const { type: chartType } = chart.config;

          const currentDataset = ['pie', 'doughnut'].includes(chartType)
            ? chart.data.datasets[0]
            : chart.data.datasets[item.datasetIndex];

          const li = document.createElement('li');
          li.classList.add(
            'text-sm',
            'd-flex',
            'align-items-center',
            'gap-2',
            'py-3',
            'cursor-pointer',
          );
          !!item.hidden && (li.style.filter = 'grayscale(100%)');

          li.onclick = () => {
            const projectStatus = (() => {
              switch (item.text) {
                case 'Collecte en cours':
                  return 'collecting';
                case 'Clôturé':
                  return 'succeeded';
                case 'Financé':
                  return 'succeeded';
                case 'Remboursé':
                case 'Terminé':
                  return 'refunded';
                case 'En retard':
                  return 'late';
                default:
                  return null;
              }
            })();

            const projectType = (() => {
              switch(item.text) {
                case 'Opération':
                  return 'CrowdfundingProject';
                case 'Locatif':
                  return 'RentalProject';
              }
            })();

            if (projectStatus) {
              window.location.href = `investissements?project_statuses[]=${projectStatus}`;
            } else if (projectType) {
              window.location.href = `investissements?project_types[]=${projectType}`;
            } else if (['pie', 'doughnut'].includes(chartType)) {
              // Pie and doughnut charts only have a single dataset and visibility is per item
              chart.toggleDataVisibility(item.index);
            } else {
              chart.setDatasetVisibility(
                item.datasetIndex,
                !chart.isDatasetVisible(item.datasetIndex)
              );
            }

            chart.update();
          };

          const colorBox = document.createElement('div');
          colorBox.style.backgroundColor = item.fillStyle;
          colorBox.classList.add(
            'p-0.75',
            'rounded-circle'
          )

          // Label
          const labelContainer = document.createElement('div');
          labelContainer.classList.add(
            'd-flex',
            'align-items-center',
            'gap-2',
            'fw-medium',
            'text-gray',
          )

          const label = document.createTextNode(item.text);
          labelContainer.appendChild(label);
          const countContainer = document.createElement('span');
          countContainer.classList.add(
            'bg-gray-100',
            'rounded-pill',
            'px-2',
            'text-black',
          )
          countContainer.style.fontVariantNumeric = 'tabular-nums';

          const value = currentDataset.data[item.index];
          const count = document.createTextNode(value);
          countContainer.appendChild(count);
          labelContainer.appendChild(countContainer);

          const caret = document.createElement('i');
          caret.classList.add('ph', 'ph-caret-right', 'fs-5', 'ms-auto');

          li.appendChild(colorBox);
          li.appendChild(labelContainer);
          li.appendChild(caret);

          ul.appendChild(li);
        });
      },
    };
  }

  return functions;
})();

// Expose top-level declarations as globals (pre-bundler concatenation behavior).
window.PieCustomLegendPluginRebranding = PieCustomLegendPluginRebranding;
